/**
 * Quick result capture → evidence *candidates* (structured facts).
 * E-levels are assigned only by validateEvidenceLevel — never blindly from the click.
 */

import { validateEvidenceLevel } from './evidence';

export const OUTCOME_OPTIONS = [
  { id: 'no_response', label: 'No response', factHint: 'No reply from counterparty after outreach.' },
  { id: 'conversation', label: 'Conversation happened', factHint: 'A conversation or meeting with the counterparty occurred.' },
  { id: 'problem_confirmed', label: 'Problem confirmed', factHint: 'Counterparty confirmed a relevant problem or use case.' },
  { id: 'info_shared', label: 'Information/asset shared', factHint: 'Counterparty shared information, documents, or named-asset detail.' },
  { id: 'proposal_requested', label: 'Proposal or budget requested', factHint: 'Counterparty requested a proposal or acknowledged budget discussion.' },
  { id: 'signed_paid', label: 'Signed/paid', factHint: 'Counterparty signed or paid — binding commercial proof claimed; requires validation.' },
];

/**
 * Build an evidence candidate from a commercial outcome.
 * Does NOT force E4/E5 — validator may demote or reject proof claims.
 */
export function evidenceCandidateFromOutcome({
  outcomeId,
  action,
  today,
  note = '',
}) {
  const opt = OUTCOME_OPTIONS.find((o) => o.id === outcomeId) || OUTCOME_OPTIONS[0];
  const counterparty =
    action?.linkedLabel ||
    action?.linkedAccount ||
    '';
  const title = `${opt.label}${counterparty ? ` — ${counterparty}` : ''}`;
  const description = [opt.factHint, note].filter(Boolean).join(' ');

  // Suggested ceiling only — never trusted as final for E4/E5 without validation.
  const requestedCeiling = {
    no_response: 'ACT',
    conversation: 'E1',
    problem_confirmed: 'E2',
    info_shared: 'E3',
    proposal_requested: 'E3', // not E4 — validator must see commercial proof language + counterparty
    signed_paid: 'E3', // not E5 — click alone is insufficient
  }[outcomeId] || 'ACT';

  const draft = {
    date: today,
    title,
    description,
    counterparty: String(counterparty || '').trim(),
    market: action?.workstream === 'Saudi' ? 'Saudi' : action?.workstream === 'Infrastructure' ? 'Infrastructure' : 'Dubai',
    level: requestedCeiling,
    source: 'outcome_capture',
    outcomeId,
    candidate: true,
    linkedActionId: action?.id || '',
    linkedKind: action?.linkedKind || '',
    linkedId: action?.linkedId || '',
  };

  const validated = validateEvidenceLevel(draft);
  return {
    record: {
      ...draft,
      level: validated.level,
      validationOk: validated.ok,
      validationReason: validated.reason || '',
      suggestedLevel: validated.suggested || validated.level,
    },
    validation: validated,
  };
}
